import React, { useState, useEffect } from "react";
import "./Footer.scss";
import moment from "moment";

const Footer = (props) => (
    <footer className="footer">
        <Clock></Clock>
        <RouteIndicator
            routeList={props.routeList}
            currentRoute={props.currentRoute}
            routeColours={props.routeColours}
        ></RouteIndicator>
    </footer>
);

const RouteIndicator = (props) => {
    const routeIcons =
        props.routeList && props.routeList.length
            ? props.routeList.map((route) => {
                const routeNumber = route.replace(/\D/g, "");
                const backgroundColour = props.routeColours.find((obj) => obj.RouteNo == routeNumber)
                    ? props.routeColours.find((obj) => obj.RouteNo == routeNumber).PIDColour
                    : "";
                const textColour = props.routeColours.find((obj) => obj.RouteNo == routeNumber)
                    ? props.routeColours.find((obj) => obj.RouteNo == routeNumber).TextColour
                    : "";
                return (
                    <div
                        className={
                            "route-indicator-item " +
                            (route === props.currentRoute ? "selected" : "")
                        }
                        style={{
                            backgroundColor: backgroundColour,
                            color: textColour,
                        }}
                        key={route}
                    >
                        <span>{route}</span>
                    </div>
                );
            })
            : "";
    return (
        <div className="route-indicator">
            {props.routeList && props.routeList.length && (
                <div
                    className="route-indicator-selector"
                    style={{
                        marginLeft:
                            2.4 *
                            (props &&
                                props.routeList &&
                                props.routeList.indexOf(props.currentRoute)) +
                            "rem",
                    }}
                ></div>
            )}
            {routeIcons}
        </div>
    );
};

const Clock = (props) => {
    //Setting up time
    const [time, setTime] = useState(moment());
    //Adding function to set latest time
    function tick() {
        setTime(moment());
    }
    //Using useEffect manipulate state in a function
    useEffect(() => {
        //Creating a timer to run once a second
        var timerId = setInterval(() => tick(), 1000);
        //Returning a cleanup function that will
        //run when the component unloads
        return function cleanup() {
            clearInterval(timerId);
        };
    });

    //Formatting the time
    var timeFormat = time.format("h:mma");

    return <div className="clock">{timeFormat}</div>;
};

export default Footer;
